export const API_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'http://localhost:3000';
export const TIMEOUT = process.env.REACT_APP_API_TIMEOUT ? process.env.REACT_APP_API_TIMEOUT : 30000;
export const COPYRIGHT = "\u00A9 Doit Platform | Portal Application System 2025";

export const INSTALLMENT_TYPE = {
  FLAT: process.env.REACT_APP_FLAT ? process.env.REACT_APP_FLAT : '6288d583dd630bef134f2fab',
  FLAT_NON_POKOK: process.env.REACT_APP_FLAT_NON_POKOK ? process.env.REACT_APP_FLAT_NON_POKOK : '6288d5a0dd630bef134f2fac',
  QORDUL_HASAN: process.env.REACT_APP_QORDUL_HASAN ? process.env.REACT_APP_QORDUL_HASAN : '6288d5c4dd630bef134f2fad',
  ANUITAS_ARREAR: process.env.REACT_APP_ANUITAS_ARREAR ? process.env.REACT_APP_ANUITAS_ARREAR : '6288d5dadd630bef134f2fae',
  FLAT_EFEKTIF: process.env.REACT_APP_FLAT_EFEKTIF ? process.env.REACT_APP_FLAT_EFEKTIF : '6461eef6f0320f77a0e71b64',
}

export const AVALIST_TYPE = {
  GROSS: 'gross',
  NETT: 'nett',
}

export const AKAD_TYPE = {
  MUDHARABAH: process.env.REACT_APP_MUDHARABAH ? process.env.REACT_APP_MUDHARABAH : "623021732d7c04f15930a7fa",
  MURABAHAH: process.env.REACT_APP_MURABAHAH ? process.env.REACT_APP_MURABAHAH : "623021732d7c04f15930a7fb",
  MUSYARAKAH: process.env.REACT_APP_MUSYARAKAH ? process.env.REACT_APP_MUSYARAKAH : "623021732d7c04f15930a7fc",
  IJAROH: process.env.REACT_APP_IJAROH ? process.env.REACT_APP_IJAROH : "623021732d7c04f15930a7fd",
}

export const MODALACTION = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  VIEW: 'VIEW'
};

export const FORM_STATUS = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  VIEW: 'VIEW'
};

export const RESPONSE = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  INVALID: 'INVALID',
  ADDED: 'ADDED',
  INFO: 'INFO'
};

export const COMPONENT_PARAMETER = {
  TEXTBOX: 'textbox',
  CHOICE: 'choice',
  DIVIDER: 'divider',
  DATEPICKER: 'datepicker',
  DATETIMEPICKER: 'datetimepicker',
  NUMBER: 'number',
  MONEY: 'money'
}

export const STATUS_PRODUCT = {
  DRAFT: 'draft',
  ACTIVE: 'active'
}

export const STATUS_DATA_ENTRY = {
  DRAFT: 'draft',
  STAGING: 'staging',
  LOAN: 'loan',
  REALIZATION: 'realization',
  DISBURSEMENT: 'disbursement',
  PAIDOFF: 'paidOff',
}

export const STATUS_BATCH_SOURCE_FUND = {
  DRAFT: 'draft',
  RUNNING: 'running',
  FINISHED: 'finished',
  FINISHED_DROPPING: 'finished_dropping'
}

export const STATUS_SOURCE_FUND_DROPPING = {
  WAITING: 'waiting',
  DONE: 'done',
}

export const STATUS_ASSETS = {
  DEPRECIATE: 0,
  NONDEPRECIATE: 1
}

export const TYPE_SUBMIT = {
  SAVE: 'save', //save only
  SUBMIT: 'submit', //save and submit (change status)
  SUBMITNEW: 'submitnew' //submit & new form
}

export const MIME_TYPE = {
  jpg: 'image/jpeg',
  png: 'image/png',
  pdf: 'application/pdf',
  doc: 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
}

export const STATUS_VERIFIKASI_SLIK = {
  NEW: 0,
  DRAFT: 1,
  STAGING: 2
}

export const STATUS_TRX_ADM = {
  SUCCESS: 1,
  ONPROGRESS: 0,
}

export const TELLER_TRANSACTION_TYPE = {
  SAVING: 1,
  WITHDRAWAL: 2 
}

export const TELLER_MODULE = {
  SAVINGS: 'savings'
}

export const STATUS_TRANSACTION_COLLECTIVE = {
  DRAFT: 'draft',
  FINISH: 'finish',
}

export const STATUS_INSURANCE = {
  PAID: 'paid',
  UNPAID: 'unpaid',
}

export const STATUS_CUSTOMER = {
  CALON: "0",
  AKTIF: "1",
  NONAKTIF: "2",
}

export const TRANSACTION_ENTRY = {
  DEBIT: 'D',
  CREDIT: 'K'
}

export const SAVINGS_TYPE = {
  WADIAH_SAVING: '004',
  MUDHARABAH_SAVING: '005',
  MUDHARABAH_DEPOSIT: '006',
}

export const STATUS_SAVING = {
  BLOCK: 1,
  UNBLOCK: 2,
  CLOSED: 3,
  ACTIVE: 'active',
  INACTIVE: 'non-active',
  CLOSEDSTRING: 'closed',
}

export const TYPE_REPORT = {
  GLOBAL: 1,
  DETAIL: 2,
}

export const STATUS_SETUP_JOURNAL = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

export const STATUS_REPAYMENT = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
  SUBMITTED: 'submitted',
  APPROVED_CLOSING: 'approved-closing-financing',
}

export const COLLECTABILITY_COLOR = new Map([
  ["1", 'success'],
  ["2", 'info'],
  ["3", 'yellow'],
  ["4", 'warning'],
  ["5", 'danger'],
]);